import { Component, OnInit } from '@angular/core';
import {ApiRestService} from "../_services/api-rest.service";
import {Dashboard, DefaultChartElement} from "../models/dashboard";
import {ClassicType} from "../models/ClassicType";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {TranslateService} from '@ngx-translate/core';
import {DatePipe} from "@angular/common";
import {RicercaPaginazione} from "../../Admin/models/sendpersonale";
import {PersonaleStoreService} from "../../Admin/_service/personale-store.service";
@Component({
  selector: 'app-Dashboard',
  templateUrl: './DashboardAmministrativa.component.html',
  styleUrls: ['./DashboardAmministrativa.component.css']
})
export class DashboardAmministrativaComponent implements OnInit {
  periodi: ClassicType[] = [{id:"1", label:"Primo Trimestre"},{id:"2", label:"Secondo Trimestre"},{id:"3", label:"Terzo Trimestre"},{id:"4", label:"Quarto Trimestre"},{id:"A", label:"Anno"}];
  periodo: ClassicType[] = [{id:"1", label:"Primo Trimestre"}];
  today = new Date();
  anno: number = new Date().getFullYear();
  AgenzieSelezionate: any[] = [];
  Agenzie: any[] =[];
  inizio = this.datepipe.transform(new Date(this.today.getFullYear(), 0, 1), 'yyyy-MM-dd');
  fine = this.datepipe.transform(new Date(this.today.getFullYear(), 12, 0), 'yyyy-MM-dd');
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: "id",
    textField: 'label',
    allowSearchFilter: false,
    allowRemoteDataSearch: false,
  };
  personedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: "id",
    textField: 'fullName',
    allowSearchFilter: true,
  };
  data: Dashboard = new Dashboard();
  sped_corrieri_Graphic_Data: any;
  imp_corrieri_Graphic_Data: any;
  costi_Graphic_Data: any;
  resoconto_Graphic_Data: any;

  constructor(private ApiRestService: ApiRestService, public translate: TranslateService, private datepipe: DatePipe, private personaleStore: PersonaleStoreService) {

  }
  ngOnInit() {
    this.refresh();
  }
  refresh(){
    const request=new RicercaPaginazione('',1,200, 'F')
      this.personaleStore.getListaPersonale(request);
    this.personaleStore.$listaPersonale.subscribe(persone=>{
      this.Agenzie = persone?.data;
    })
    this.ApiRestService.GetDashboardLaeraData({
      periodo: true,
      inizio : this.inizio,
      fine   : this.fine,
      agenzia: this.AgenzieSelezionate?.find(a=>true)?.id
    }).subscribe((data)=>{
      this.data = data;
      this.sped_corrieri_Graphic_Data = this.GetGraphicData(data.sped_corrieri,false);
      this.imp_corrieri_Graphic_Data = this.GetGraphicData(data.imp_corrieri,true);
      this.costi_Graphic_Data = this.GetGraphicData(data.costi,true);
      this.resoconto_Graphic_Data = this.resoconto_to_VerticalBar(data.resoconto)
    });
  }


  GetGraphicData(data: ClassicType[], isEuro: boolean ){
    var out = {
      series: [],
      labels: [],
      colors:['#00FF00', '#FF8C00', '#0000ff', '#ff0000','#9400d3','#00ffff', '#a9a9a9', '#51766d', '#ebd18f','#b4b3cc'],
      chart: {
        height: 300,
        type: "polarArea"
      },
      stroke: {
        colors: ["#fff"]
      },
      fill: {
        opacity: 0.8
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    };
    data.forEach(element=>{
      out.series.push(parseFloat(element.value));
      if(isEuro)
        out.labels.push(element.label + "  " + parseFloat(element.value)+ "€")
      else
        out.labels.push(element.label + "  " + parseFloat(element.value))
    })
    return out;
  }



  ClassicType_to_namevalue(data: ClassicType[]){
    var out:any = [];
    data.forEach(element=>{
      out.push({name: element.label,value: parseFloat(element.value)})
    })
    return out;
  }
  ClassicType_to_VerticalBar(data: ClassicType[]){
    var out:any = [];
    data.forEach(element=>{
      out.push({name :element.label, series:[{name: element.label, value: parseFloat(element.value)}]});
    })
    return out;
  }

  resoconto_to_VerticalBar(data){
    const Mesi: string[] = ['Gennaio','febbraio', 'marzo','Aprile', 'Maggio' , 'Giugno' , 'Luglio' , 'Agosto' , 'Settembre' , 'Ottobre' , 'Novembre' , 'Dicembre'];
    var out:any = [];
    for (var i=0; i< Mesi.length ; i++){
      if(data.length>i)
        out.push({name :Mesi[i], series:[{name: 'Fatturato', value: parseFloat(data[i][0])},{name: 'Costi', value: parseFloat(data[i][1])}]});
    }
    return out;
  }






  // lineChart1Fill(italia: DefaultChartElement[], estero: DefaultChartElement[], totale: DefaultChartElement[]){
  //   var newValues = [];
  //   newValues.push({data:this.getValues(italia), label: 'Italia'});
  //   newValues.push({data:this.getValues(estero), label: 'Estero'});
  //   newValues.push({data:this.getValues(totale), label: 'Totale'});
  //   this.lineChartData = newValues;
  //   this.lineChartLabels = this.getLabels(totale);
  // }
  // lineChart2Fill(b2c: DefaultChartElement[], b2b: DefaultChartElement[], pl: DefaultChartElement[], b2b2c: DefaultChartElement[], totale: DefaultChartElement[]){
  //   var newValues = [];
  //   newValues.push({data:this.getValues(b2c), label: 'B2C'});
  //   newValues.push({data:this.getValues(b2b), label: 'B2B'});
  //   newValues.push({data:this.getValues(pl), label: 'Private label'});
  //   newValues.push({data:this.getValues(b2b2c), label: 'B2B2C'});
  //   newValues.push({data:this.getValues(totale), label: 'Totale'});
  //   this.lineChartData2 = newValues;
  //   this.lineChartLabels2 = this.getLabels(totale);
  // }

  // getValues(data: DefaultChartElement[]): number[]{
  //   var out: number[] = [];
  //   data.forEach(element=>{
  //     out.push( parseFloat(element.value.toString()))
  //   })
  //   return out;
  // }
  // getLabels(data: DefaultChartElement[]): string[]{
  //   var out: string[] = [];
  //   data.forEach(element=>{
  //     out.push( element.label);
  //   });
  //   return out;
  // }



}
